var map = {
	"./VScode.svg": 4287,
	"./blender.svg": 515,
	"./css.svg": 9154,
	"./excel.svg": 3015,
	"./git.svg": 745,
	"./github.svg": 9621,
	"./html.svg": 8354,
	"./js.svg": 2139,
	"./photoshop.svg": 9461,
	"./powerpoint.svg": 9812,
	"./sass.svg": 9423,
	"./scrum.svg": 6706,
	"./ts.svg": 9648,
	"./vue.svg": 8955,
	"./vuetify.svg": 4142,
	"./word.svg": 6639
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3031;